import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { SorareLogo } from '#src/atoms/icons/SorareLogo/index.tsx';
import { SmallerStarBall } from '#src/atoms/navigation/SmallerStarBall/index.tsx';
import { LANDING } from '#src/constants/__generated__/routes.ts';
import { tabletAndAbove } from '#src/style/mediaQuery.ts';

const ResponsiveSorareLogo = styled(SorareLogo)`
  display: none;
  @media ${tabletAndAbove} {
    display: block;
  }
`;

const Logo = styled(Link)`
  display: flex;
  gap: var(--unit);
  align-items: center;
`;

type Props = {
  withStarball?: boolean;
};

export const HomeLink = ({ withStarball = false }: Props) => {
  return (
    <Logo to={LANDING} aria-label="Sorare">
      {!!withStarball && <SmallerStarBall />}
      <ResponsiveSorareLogo />
    </Logo>
  );
};
